import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 32 32"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M30.233 0H1.767A1.77 1.77 0 0 0 0 1.767v28.466A1.77 1.77 0 0 0 1.767 32H16V19.333h-3.825v-4.666H16v-3.45c0-4.133 2.867-6.383 6.558-6.383 1.767 0 3.667.133 4.108.192v4.317h-2.941c-2.008 0-2.392.95-2.392 2.35v2.975h4.783l-.625 4.667h-4.158V32h8.9A1.77 1.77 0 0 0 32 30.233V1.767A1.77 1.77 0 0 0 30.233 0",
      "data-name": "Icon ionic-logo-facebook"
    }, null, -1)
  ])))
}
export default { render: render }